export const TOOLTIP_FOOTNOTE_TEMPLATES = [
  {
    id: crypto.randomUUID(),
    macroType: "tooltip",
    color: { light: "#1D7AFC", dark: "#388BFF" },
    textColor: { light: "#FFFFFF", dark: "#FFFFFF" },
    description: "A tooltip provides additional information about an element.",
  },
  {
    id: crypto.randomUUID(),
    macroType: "footnote",
    color: { light: "#1D7AFC", dark: "#388BFF" },
    textColor: { light: "#FFFFFF", dark: "#FFFFFF" },
    description: "A footnote provides additional information about an element.",
  },
];

export const getTooltipFootnoteTemplates = ({ selectedColors }) => {
  return TOOLTIP_FOOTNOTE_TEMPLATES.map((template) => {
    return {
      ...template,
      color: {
        light: selectedColors?.light[0]?.accent || "#1D7AFC",
        dark: selectedColors?.dark[0]?.accent || "#388BFF",
      },
      textColor: {
        light: selectedColors?.light[0]?.text || "#FFFFFF",
        dark: selectedColors?.dark[0]?.text || "#FFFFFF",
      },
    };
  });
};
